import { useCampaignContext } from 'modules/campaigns/editor/context';
import { CampaignState } from 'modules/domains/campaign';
import {
  AbortCampaignAction,
  BausOverflowMenu,
  CancelCampaignAction,
  InAppRecallAction,
  RescheduleCampaignAction,
  ScheduleCampaignAction,
  SendCampaignNowAction,
  ViewAnalyticsAction,
} from '../Actions';
import { CampaignSummaryOverflowMenu } from '../Actions/CampaignSummaryOverflowMenu';

/**
 * Mapper of actions for a given campaign state
 */
const BLAST_CAMPAIGN_STATES_ACTION_COMPONENTS_MAPPER: Record<
  CampaignState,
  (() => JSX.Element | null)[]
> = {
  [CampaignState.Draft]: [SendCampaignNowAction, ScheduleCampaignAction],
  [CampaignState.Ready]: [SendCampaignNowAction, ScheduleCampaignAction],

  [CampaignState.Scheduled]: [
    CampaignSummaryOverflowMenu,
    RescheduleCampaignAction,
    CancelCampaignAction,
  ],

  [CampaignState.Running]: [BausOverflowMenu, ViewAnalyticsAction, AbortCampaignAction],
  [CampaignState.Recurring]: [RescheduleCampaignAction, CancelCampaignAction],

  [CampaignState.Finished]: [BausOverflowMenu, InAppRecallAction, ViewAnalyticsAction],
  [CampaignState.Aborted]: [BausOverflowMenu, InAppRecallAction, ViewAnalyticsAction],
  [CampaignState.Archived]: [ViewAnalyticsAction],

  [CampaignState.Recalled]: [ViewAnalyticsAction],
  [CampaignState.Recalling]: [InAppRecallAction, ViewAnalyticsAction],
};

export const BlastCampaignSummaryViewActions = () => {
  const {
    campaign: { campaignState },
  } = useCampaignContext();

  const actions = BLAST_CAMPAIGN_STATES_ACTION_COMPONENTS_MAPPER?.[campaignState];

  return (
    <>
      {actions?.map((Action, i) => (
        <Action key={i} />
      ))}
    </>
  );
};
